import { Input } from 'components/elements';
import CustomerSelectInput from 'legacy-modules/master/customer/components/select-input';
import {
  FullContainer,
  HalfContainer,
  SectionContainer,
} from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';

export default function InformationField() {
  const { t } = useTranslation();
  return (
    <FullContainer>
      <SectionContainer>
        <HalfContainer>
          <Input
            type="text"
            name="invoiceNumber"
            label={t('common:invoice_number')}
            placeholder={t('common:invoice_number')}
            required
            disabled
          />
        </HalfContainer>
        <HalfContainer>
          <Input
            type="text"
            name="number"
            label={t('common:number')}
            placeholder={t('common:number')}
            required
          />
        </HalfContainer>
      </SectionContainer>
      <SectionContainer>
        <HalfContainer>
          <Input
            type="date-time"
            name="requestedAt"
            label={t('refund:requested_at')}
            placeholder={t('refund:requested_at')}
            required
            disabled
          />
        </HalfContainer>
        <HalfContainer>
          <CustomerSelectInput name="customerId" required />
        </HalfContainer>
      </SectionContainer>
      <SectionContainer>
        <HalfContainer>
          <Input
            type="number"
            name="refundAmount"
            label={t('refund:refund_amount')}
            placeholder={t('refund:refund_amount')}
            disabled
            required
          />
        </HalfContainer>
        <HalfContainer>
          <Input
            type="text"
            name="reason"
            label={t('refund:refund_reason')}
            placeholder={t('refund:refund_reason')}
            required
            disabled
          />
        </HalfContainer>
      </SectionContainer>
    </FullContainer>
  );
}
